import { Link } from "react-router-dom";
import "../../../App.scss";
import "./home-modern.scss";

import { caseStudies, homeSections } from "../../../data/caseStudies";

function HomeSection({ title, subtitle, items }) {
  return (
    <section className="home-section">
      <div className="home-section__heading">
        <p className="home-section__eyebrow">{subtitle}</p>
        <h2>{title}</h2>
      </div>
      <div className="home-section__grid">
        {items.map((item) => (
          <Link className="home-card" to={`/${item.slug}`} key={item.slug}>
            <div className="home-card__image-wrap">
              <img
                src={item.heroImage}
                alt={item.title}
                className="home-card__image"
              />
            </div>
            <div className="home-card__content">
              <p className="home-card__category">{item.category}</p>
              <h3>{item.title}</h3>
              <p>{item.overview.role}</p>
              <p className="home-card__summary">{item.overview.summary}</p>
              <span className="home-card__cta">View case study</span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}

function Home() {
  const deloitte = homeSections.deloitte.map((key) => caseStudies[key]);
  const currentWork = homeSections.currentWork.map((key) => caseStudies[key]);
  const foundational = homeSections.foundational.map((key) => caseStudies[key]);
  const personal = homeSections.personal.map((key) => caseStudies[key]);

  return (
    <>
      <div className="home-hero">
        <div className="home-hero__inner">
          <p className="home-hero__eyebrow">Michael Cameron</p>
          <h1> DESIGNER/ STRATEGIST</h1>
          <h3 className="home-hero__lede">
            I turn ambiguity into clear, deliverable products.
          </h3>
          <div className="home-hero__pills">
            <span>AI Product Strategy</span>
            <span>Service design</span>
            <span>AI-enabled Transformation</span>
            <span>Enterprise Modernization</span>
          </div>
        </div>
      </div>

      {/* <HeaderBar
        Descr="PORTFOLIO"
        Location="CASE STUDIES"
        time="SELECTED WORK"
      />
 */}
      <div className="home-shell">
        <section className="home-intro">
          <div>
            <p className="home-section__eyebrow">History</p>
            <h2>My Projects</h2>
          </div>
          <p>
            Each case study is structured to show the problem, the complexity,
            the role I owned, the decisions I drove, and the outcomes the work
            enabled.
          </p>
        </section>

        <HomeSection
          title="AI-Driven Transformation"
          subtitle="Current work"
          items={deloitte}
        />

        <HomeSection
          title="Service & Systems Design"
          subtitle="Steampunk work"
          items={currentWork}
        />

        <HomeSection
          title="Foundational Experience"
          subtitle="Homeland Security Solutions"
          items={foundational}
        />

        <HomeSection
          title="Innovation and Product Ownership"
          subtitle="Independent work"
          items={personal}
        />
        <div className="home-footer m-auto w-85 h-100px">
          <p>Get in touch</p>
          <a href="mailto:mrcameron808@gmail.com">
            <h3>mrcameron808@gmail.com</h3>
          </a>{" "}
        </div>
      </div>
    </>
  );
}

export default Home;
